export default "__VITE_ASSET__e4e38f64__$_?component__"